import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { constants } from 'common/helpers'

import Modal from 'components/modal/Modal/Modal'
import WeMissedYouContent from 'components/WeMissedYouContent/WeMissedYouContent'

import messages from './messages'
import s from './NeedUpdateCardModal.scss'


class NeedUpdateCardModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    firstName: PropTypes.string,
    onClose: PropTypes.func,
  }

  static defaultProps = {
    name: constants.modals.limitedEditionProducts.NeedUpdateCard,
    firstName: '',
  }

  close = () => {
    const { name, onClose } = this.props

    actions.models.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  render() {
    const { name, firstName, onClose } = this.props

    return (
      <Modal
        className={s.weMissedYouModal}
        name={name}
        title={messages.title}
        onClose={onClose}
      >
        <WeMissedYouContent firstName={firstName} isLEPNeedUpdateCard onClose={this.close} />
      </Modal>
    )
  }
}


export default connect({
  firstName: 'models.me.firstName',
})(NeedUpdateCardModal)
